import { Link } from "react-router-dom";
import logoSvg from "../assets/logo.svg";
import CustomLanguageSelector from "./CustomLanguageSelector";
import "./AdsHeader.css";

/**
 * Stripped-down header for the paid-ads landing page (/free-kundli-matching).
 *
 * Brand on the left, language picker on the right, nothing else. An ad landing
 * page is paid for per click, so every nav item is a way to spend that click on
 * something other than the form. Same reasoning as /india's focused mode, taken
 * one step further because this page has a single conversion target.
 *
 * Rendered INSTEAD of <Navbar />, never alongside it: App.tsx swaps the two, so
 * the prerendered HTML still contains exactly one <nav>. Two would be a
 * duplicate-landmark accessibility problem and the exact bug the comment above
 * <Navbar /> warns about.
 *
 * The language picker is the same <CustomLanguageSelector /> the main navbar
 * uses, so it drives the same Google Translate widget (mounted globally in
 * AppContent) and honours the same stored preference. Nothing forked.
 */
export default function AdsHeader() {
  return (
    /* No aria-label="Primary": BottomNav already claims that name, and two
       landmarks sharing one label is worse for a screen reader than one being
       unnamed. The real navbar does not label itself either. */
    <nav className="adshdr">
      <Link to="/" className="adshdr__brand">
        <img src={logoSvg} alt="Aura AI" className="adshdr__logo" />
        <span className="adshdr__name">Aura AI</span>
      </Link>

      <div className="adshdr__lang">
        <CustomLanguageSelector />
      </div>
    </nav>
  );
}
